/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateRestructuringRequest {
  id?: string;
  planId?: string | null;
  state?: UpdateRestructuringRequestStateEnum | null;
  isFrozen?: boolean;
  reason?: string | null;
}
export enum UpdateRestructuringRequestStateEnum {
  Draft = 'Draft',
  Monitoring = 'Monitoring',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Published = 'Published'
}
